export function formatNumber(value: number, short?: boolean): string {
   if (value === 0) return '0';
   const isNegative = value < 0;
   value = Math.abs(value);

   if (value < 999) return isNegative ? `-${value.toLocaleString()}` : value.toLocaleString();

   const suffixes = ['', 'k', 'M', 'B', 'T'];
   const order = Math.floor(Math.log10(value) / 3);

   if (order < suffixes.length) {
      const divisor = Math.pow(10, order * 3);
      let roundedValue = value / divisor;

      if (short && roundedValue.toString().length > 5) {
         roundedValue = Math.floor(roundedValue); // Remove decimals for short format
      } else {
         roundedValue = Math.round(roundedValue * 10) / 10; // Keep one decimal place
      }

      return isNegative ? `-${roundedValue}${suffixes[order]}` : `${roundedValue}${suffixes[order]}`;
   } else {
      return isNegative ? `-${value.toString()}` : value.toString();
   }
}

export function stringToArrayConverter(str: string | null): number[] {
   if (!str) return [];
   return str.split(',').map(Number);
}
